import React from 'react';
import Navbar from '../gral-components/Navbar';
import Header from '../gral-components/Header';
import BorderCurved from '../gral-components/BorderCurved';
import Bloger from './components/Bloger.js';
import Footer from '../gral-components/Footer';
import './stylesheets/blog.scss';

import dataDearHR from '../data/dearHR/unauthenticated.json';

import blogers from '../data/users/users-blog.json';



class Blog extends React.Component { 
  render() {
    let personalInfo = JSON.parse(localStorage.getItem('personalInfo'));
    let firstname = personalInfo ? personalInfo.firstname : '';
    return (
      <div className='background-gradient-image'>
        <div
          id='header-home'
          className='header-blog'>
          <Navbar
            subscribeBar={true}
            blog={true}
            firstname={firstname}
            navbarType='blog'
            loginOpenHandle={this.props.loginOpenHandle}
            joinOpenHandle={this.props.joinOpenHandle}
          />
          <Header
            headerType='blog'
            images={blogers}
            firstname={firstname}
            textWriter={dataDearHR.textWriter.blog}
          />
        </div>
        <div className='main-content'>
          <div className='border-curved-top-container'>
            <BorderCurved
              transform={false}
              background={{
                backgroundImage: 'none'
              }}
              fill='white'
            />
          </div>
          <div className='blog-blog-content'>
            <ul className='blog-blog-item-container'>
              {
                blogers.map((user, index) => (
                  <li
                    key={index}
                    className='blog-blog-item-li'>
                    <Bloger
                      src={user.image}
                      alt={user.alt}
                      author={user.name}
                      title={user.title}
                      text={user.description}
                      date={user.date}
                      comments={user.comments}
                      likes={user.likes}
                    />
                  </li>
                ))
              }
            </ul>
          </div>
          <div className='border-curved-bottom-container'>
            <BorderCurved
              transform={true}
              background={{
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }}
              fill='white'
            />
          </div>
        </div>
        <footer
          id='footer-section'
          className='footer-section flex-column-center-center' >
          <Footer />
        </footer>
      </div>
    );
  }

};

export default Blog;